// import React from 'react'

// const ViewReturnGrnPo = () => {
//   return (
//     <div>
      
//     </div>
//   )
// }

// export default ViewReturnGrnPo

import * as React from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import InfoDisplayGrid from "../common/InfoDisplayGrid";
import { FormatDate } from "../../utils/common/DateUtils";
import { transformPoData } from "../../utils/grn/grnDataUtils";
import { AnyForNow } from "../../features/grn/types";

interface ViewGrnPoProps {
  grnDetailsForm: AnyForNow;
  grnHeader: AnyForNow;
  grnreturncode?: string;
  returneddate?: string;
  grncode?: string;
}

const ViewReturnGrnPo: React.FC<ViewGrnPoProps> = (props) => {
  const { grnDetailsForm, grnHeader, grnreturncode, returneddate, grncode } = props;
  const theme = useTheme();
  const styles = useStyles(theme);

  const poData = transformPoData(grnDetailsForm, grnHeader);
console.log("df",returneddate)
// const poInfoData = [
//   { label: "PO Number", value: poData.poNumber },
//   { label: "PO Date", value: FormatDate(poData.poDate) },
//   { label: "Invoice Number", value: poData.invoiceNumber },
//   { label: "Invoice Date", value: FormatDate(poData.invoiceDate) },
//   { label: "Dispatched Number", value: poData.dispatchNumber },
//   { label: "Dispatched Date", value: FormatDate(poData.dispatchDate) },
//   { label: "Delivery Note Number", value: poData.deliveryNoteNumber },
//   { label: "Delivery Date", value: FormatDate(poData.deliveryDate) },
//   { label: "Delivery Location", value: poData.deliveryLocation },
//   { label: "Partial Shipments", value: poData.partialShipments },
//   { label: "AWB Number", value: poData.awbNumber },
//   { label: "Bill of Lading Number", value: poData.billOfLandingNumber },
//   { label: "Purchases Return Number", value: grnreturncode },
// {
//   label: "Purchases Return Date",
//   value: FormatDate(returneddate),
// }
// ].filter((item) => item?.label && item?.value !== undefined && item?.value !== null && item?.value !== "");
  const poInfoData = [
  
    { label: "PO Number", value: poData.poNumber },
    { label: "PO Date", value: FormatDate(poData.poDate) },
    { label: "Invoice Number", value: poData.invoiceNumber },
    { label: "Invoice Date", value: FormatDate(poData.invoiceDate) },
    { label: "Dispatched Number", value: poData.dispatchNumber },
    { label: "Dispatched Date", value: FormatDate(poData.dispatchDate) },
    { label: "Delivery Note Number", value: poData.deliveryNoteNumber },
    { label: "Delivery Date", value: FormatDate(poData.deliveryDate) },
    { label: "Delivery Location", value: poData.deliveryLocation },
    { label: "Partial Shipments", value: poData.partialShipments },
    { label: "AWB Number", value: poData.awbNumber },
    { label: "Bill of Lading Number", value: poData.billOfLandingNumber },
        //z{ label: "Serial Number" },
         { label: "Purchases Return Number", value:grnreturncode  },
          { label: "Purchases Return Date", value: FormatDate(returneddate)   },
  ];
  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12 }}>
        <InfoDisplayGrid data={poInfoData} />
      </Grid>
    </Grid>
  );
};

export default ViewReturnGrnPo;